// eslint-disable-next-line
export default [
    {
        code: 'wgHt23F',
        value: 0.2
    },
    {
        code: 'gZIPrhn',
        value: 0.1
    },
    {
        code: '35354ab',
        value: 0.05
    },
    {
        code: '23c45df',
        value: 0.3
    },
    {
        code: '1e1e1ea',
        value: 0.45
    },
    {
        code: '5400dea',
        value: 0.25
    },
    {
        code: '79ae3tq',
        value: 0.4
    },
    {
        code: '64ttt23',
        value: 0.5
    }
]